import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ScriptList, { ScriptItem } from '../../../../components/chatScripts/ScriptList/ScriptList';
import Loader from '../../../../components/loader/Loader';
import useFetchUserInfos from '../../../../hooks/userHooks/useFetchUserInfos';
import { useScriptSearch } from '../../../../hooks/chatScript/useScriptSearch';
import './SearchScriptsView.less';

export type SearchScriptsViewProps = {
  allItems: ScriptItem[];
  onCancel: () => void;
};

const SearchScriptsView: React.FC<SearchScriptsViewProps> = ({ allItems, onCancel }) => {
  const { t } = useTranslation();
  const { currentUser } = useFetchUserInfos();
  const currentCreator = currentUser?.id;
  const [query, setQuery] = useState('');
  const { shouldUseBackend, items, loading, listRef, sentinelRef } = useScriptSearch({ query, allItems, creatorId: currentCreator });

  return (
    <div className="search-scripts-view">
      <div className="search-bar">
        <input className="search-input" placeholder={t('search') as string} value={query} onChange={(e) => setQuery(e.target.value)} autoFocus />
        <button className="search-cancel" onClick={onCancel} type="button">
          {t('cancel') as string}
        </button>
      </div>
      <div className="search-results">
        {shouldUseBackend ? (
          loading && items.length === 0 ? (
            <div className="loader-wrapper">
              <Loader />
            </div>
          ) : items.length === 0 ? (
            <div className="search-empty">{t('search-no-results')}</div>
          ) : (
            <>
              <ScriptList items={items} loading={loading && items.length === 0} listRef={listRef} sentinelRef={sentinelRef} />
              {loading && items.length > 0 && (
                <div className="loader-script-wrapper">
                  <Loader />
                </div>
              )}
            </>
          )
        ) : (
          <ScriptList items={items} />
        )}
      </div>
    </div>
  );
};

export default SearchScriptsView;
